/**
 * See https://www.coderchamp.com/count-words-and-characters-in-javascript/
 */
export const generateQuote = (
  quote: string,
  numberOfWords: number = 0
): string => {
  if (typeof quote === 'string') {
    const filteredQuote = quote
      .trim()
      .split(/\s+/)
      .filter(str => str !== '');

    if (filteredQuote.length > numberOfWords) {
      return filteredQuote.splice(0, numberOfWords).join(' ');
    }

    return filteredQuote.join(' ');
  }

  return '';
};
